import { darken } from 'polished';

import { DEFAULT_BRANDING } from 'constants/branding';

/**
 * Build a theme for the application using the given branding.
 *
 * @method buildThemeWithConfig
 * @param  {Object}             [branding=DEFAULT_BRANDING] The branding config
 * @return {Object}                                         The final theme
 */
export function buildThemeWithConfig(branding = DEFAULT_BRANDING) {
    return {
        palette: {
            primary: {
                text         : branding.primaryTextColor,
                gradientColor: branding.primaryColor,
                color        : darken(0.1, branding.primaryColor),
                borderColor  : branding.primaryColor
            },
            secondary: {
                text         : branding.secondaryTextColor,
                gradientColor: branding.secondaryColor,
                color        : darken(0.1, branding.secondaryColor),
                borderColor  : branding.secondaryColor
            },
            links: {
                color: branding.linkTextColor
            }
        },
        typography: {
            oot: {
                fontFamily: `Roboto, Helvetica, Arial, sans-serif`,
                fontSize  : '14px',
                fontWeight: 400,
                margin    : '5px 0'
            },
            headline: {
                fontSize     : '1.375rem',
                fontWeight   : 500,
                lineHeight   : '1.3',
                letterSpacing: '.02em'
            }
        },
        AppNav: {
            styles: {
                backgroundColor: branding.topNavColor,
                color          : branding.topNavTextColor,
                height         : '62px'
            }
        },
        NavLogo: {
            alt   : branding.companyName,
            src   : branding.logoUrl,
            styles: {}
        }
    };
}
